<template>
    <div>
        <el-table
            :data="data"
            style="width: 100%"
            height="300"
            stripe
            :empty-text="myEmptyText">
            <el-table-column label="Nom de la fiche produit">
                <template slot="header" slot-scope="scope">
                    <selectProduct 
                        style="max-width:300px"
                        :inventoryId="inventoryId" 
                        :type="type" 
                        :active="active"
                        :disabled="disabled"
                        :summary="summary"
                        :selected="selected"
                        :showCMSName="showCMSName"
                        :placeholder="placeholder"
                        @selected="handleSelect"
                        />
                </template>
                <template slot-scope="props">
                    <span v-if="showCMSName">{{ getProductName(props.row) }}</span>
                    <span v-else>{{ getProductName(props.row) }}</span>
                </template>
            </el-table-column>
            <el-table-column width="80">
                
                <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="danger"
                    circle
                    @click="handleDelete(scope.$index, scope.row)"><i class="mdi mdi-delete fs-12"></i></el-button>
            </template>
            </el-table-column>
        </el-table>
    </div>
  </template>
  <script>
  import selectProduct from '@/components/product/select-product';
  import ProductUtil from '@/utils/product-util'
  import ProductsApi from '@/services/API/product'
  export default {
        name: 'SelectMultipleProduct',
        props: {
            inventoryId : {
                type : Number,
                default: undefined,
            },
            type: {
                type: Number,
                default: undefined,
            },
            active : {
                type : Boolean,
                default : true
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            summary: {
                type: Boolean,
                default: false
            },
            selected: {
                type: Boolean,
                default: true
            },
            showCMSName : {
                type: Boolean,
                default: false,
            },
            emptyText: {
                type: String,
                default: null
            },
            placeholder: {
                type: String,
                required: true
            },
            products: {
                type: Array,
            }
      },
      data() {
          return {
                data: [],
                loading: false,
            }
     },
    computed: {
        myEmptyText(){
            if (this.emptyText == null) {
                return this.$i18n.t('common.table.empty');
            }
            return this.emptyText
        },
    },
    components : {
        selectProduct,
    },
    methods : {
        fetchProducts(){
            this.loading = true;
            const ids = _.map(this.products, product => (product.id));
            if (!_.isEmpty(ids)) {
                return ProductsApi.listProductDefinitionV2({ id: ids, paging:'no' })
                    .then((products) => {
                        this.data.splice(0, this.data.length);
                        this.data.push(...products);
                        this.loading = true;
                    }).catch((err) => {
                        this.loading = false;
                    })
            } else {
                this.loading= false;
            } 
        },
        getProductName(product, type){
        return ProductUtil.productName(product, type);
        },
        handleDelete(index, value) {
            this.data.splice(index,1);
            this.$emit('change', this.data);
        },
        handleSelect (value) {
            if (value != null && value != '') {
                this.data.push(value);
            }
            this.$emit('change', this.data);
        },
        },
        watch: {
        products: function() {
            return this.fetchProducts();
        }
    },
    created(){
      
    }
  }
  </script>
  <style lang="scss" scoped>
  
  </style>
  